import React from 'react';
import Header from './components/header/header';
import WidgetGrid from './components/widgets/widgetGrid';
import CtaBanner from './components/widgets/cta-banner';
import Map from '../src/components/map/map';
import DrivetimeWidget from './components/widgets/drivetimeWidget';
import ViewToggle from './components/bitsnbobs/viewToggle';
import LocationSearch from './components/header/locationSearch';
import CtaFooter from './components/header/ctaFooter';
import SplashModal from './components/modals/splashModal';
import Legend from './components/map/legend';
import Scroller from './components/bitsnbobs/scroller';
import Svgs from './resources/svgs';
import FormModal from './components/modals/formModal';
import './App.scss';
import esriStrings from './resources/esriStrings';
import HomeButton from './components/map/homeButton';
import enrichFeature from './resources/enrichFeature';

function App() {

  const [initalFeature, setInitalFeature] = React.useState(null);
  const [currentFeature, setCurrentFeature] = React.useState(null);
  const [widgetData, setWidgetData] = React.useState({ tap: [], income: null, pop: null, spending: null });
  const [currentZIP, setCurrentZIP] = React.useState(null);
  const [activeWidget, setActiveWidget] = React.useState(1);
  const [esriView, setEsriView] = React.useState(null);
  const [activeView, setActiveView] = React.useState('data');
  const [activeVTLayer, setActiveVTLayer] = React.useState(null);
  const [showWidgets, setShowWidgets] = React.useState(false);
  const [showSplash, setShowSplash] = React.useState(true);
  const [lastWidget, setLastWidget] = React.useState(1);
  const [activeLegend, setActiveLegend] = React.useState(null);
  const [showLegend, setShowLegend] = React.useState(true);
  const [interactionCount, setInteractionCount] = React.useState(0);
  const [currentVisible, setCurrentVisible] = React.useState(1);
  const [formVisible, setFormVisible] = React.useState(false);
  const mapRef = React.useRef();
  const toggleRef = React.useRef();
  const handleStep = (index) => {
    setCurrentVisible(index);
    setActiveWidget(index);
    setLastWidget(index);
  };
  React.useEffect(() => {
    const target = document.querySelector('.widget-grid');
    if (target) {
      target.scrollLeft =
        document.querySelector('.widget-cell').offsetWidth * (currentVisible - 1);
    }
  }, [currentVisible]);
  const setVectorUrl = (url) => {
    mapRef.current.setVectorUrl(url);
  };
  const passSearchPoint = (mapPoint, onValidSearch, onInvalidSearch) => {
    mapRef.current.handleSearchResult(mapPoint, 'search', onValidSearch, onInvalidSearch);
  };
  const setDriveTimePoly = (geom, point) => {
    mapRef.current.setDriveTimePoly(geom, point);
  };
  const setDriveTimeVisiblity = (isVisible) => {
    mapRef.current.setDriveTimeVisiblity(isVisible);
  };
  const updateCurrentFeature = async (feature) => {
    const enriched = await enrichFeature(feature);
    setCurrentFeature(feature);
    if (enriched) {
      const attributes = enriched.attributes;
      if (attributes) {
        const { income, tap, pop, spending } = attributes;
        setWidgetData({ income, tap, pop, spending });
        setCurrentFeature(enriched);
      }
    }
  };
  // React.useEffect(() => {
  //   if (toggleRef.current) {
  //     console.log(toggleRef.current.getBoundingClientRect());
  //   }
  // }, [toggleRef.current]);
  React.useEffect(() => {
    if (activeVTLayer) {
      setVectorUrl(activeVTLayer);
    } else {
      setVectorUrl(
        'https://tiles.arcgis.com/tiles/G84Qg78md8fRCEAD/arcgis/rest/services/ZipCodes_base_vtl/VectorTileServer'
      );
    }
  }, [activeVTLayer]);
  React.useEffect(() => {
    if (esriView) {
      setActiveView('data');
    }
  }, [esriView]);
  React.useEffect(() => {
    if (activeWidget === 0) {
      setActiveWidget(lastWidget);
    }
  }, [activeView]);

  React.useEffect(() => {
    if (!initalFeature) {
      setInitalFeature(currentFeature);
    }

  }, [currentFeature]);
  // React.useEffect(() => {
  //   console.log(activeWidget);

  // }, [activeWidget]);

  return (
    <div className="App">
      <Header title={esriStrings.headerTitle}></Header>
      <LocationSearch
        esriView={esriView}
        passSearchPoint={passSearchPoint}
        currentZIP={currentZIP}
        satTitle="header"
      ></LocationSearch>
      <ViewToggle
        setShowWidgets={setShowWidgets}
        activeView={activeView}
        setActiveView={setActiveView}
        toggleRef={toggleRef}
      />
      <div className="content-wrapper">
        <div
          className={`map-wrapper${activeView === 'map' ? ' active-view' : ''}`}
        >
          {activeLegend && showLegend
            ? <Legend
              legendImage={`https://webapps-cdn.esri.com/Apps/know-your-neighborhood/img/${activeLegend}.jpg`}
            />
            : null}
          <Map
            // addInteractionCount = {}
            setCurrentZIP={setCurrentZIP}
            setEsriView={setEsriView}
            ref={mapRef}
            onFeature={updateCurrentFeature}
          //  vtUrl = {activeVTLayer}
          ></Map>
          <HomeButton
            initalFeature={initalFeature}
            view={esriView}
            passSearchPoint={passSearchPoint}
          ></HomeButton>
          {/* <DrivetimeWidget
            setShowLegend={setShowLegend}
            onWidget={setActiveWidget}
            currentFeature={currentFeature}
            activeWidget={activeWidget}
            onUpdateLayer={setActiveVTLayer}
            lastWidget={lastWidget}
            setDriveTimePoly={setDriveTimePoly}
            setDriveTimeVisiblity={setDriveTimeVisiblity}
          ></DrivetimeWidget> */}
        </div>

        <div className="widgets-wrapper">
          <WidgetGrid
            setActiveLegend={setActiveLegend}
            isActive={activeView !== 'map' || showWidgets}
            setCurrentVisible={setCurrentVisible}
            currentVisible={currentVisible}
            onWidget={setActiveWidget}
            activeWidget={activeWidget}
            widgetData={widgetData}
            currentFeature={currentFeature}
            onUpdateLayer={setActiveVTLayer}
          ></WidgetGrid>
          <Scroller
            maxIndex={4}
            handleStep={handleStep}
            currentVisible={currentVisible}
          />
          <CtaBanner formVisible={formVisible} showForm={setFormVisible} />
        </div>
      </div>
      <CtaFooter formVisible={formVisible} showForm={setFormVisible}></CtaFooter>
      <SplashModal
        setShowSplash={setShowSplash}
        passSearchPoint={passSearchPoint}
        esriView={esriView}
        isVisible={showSplash}
      ></SplashModal>
      {/* <FormModal showForm = {setFormVisible} isVisible = {formVisible}></FormModal> */}
      <div className="blocker">
        <h1>{esriStrings.rotateScreen}</h1>
      </div>
    </div>
  );
}

export default App;
